import { Box, Icons, Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../Dropdown';
import { AMLCaption } from './AMLCaption';
import { AMLCompletedResult } from './AMLCompletedResult';
import { JobExecutionStatus } from 'models/jobs/shared';
import { useGlobalState } from 'store/reducers/reducer';
import { retrieveAmlDetailed } from 'store/sagas/sagas';
export const AMLDropdowns = ({ isAMLOnly, jobAMLResults, jobErrors, jobSid, jobStatus }) => {
    const { asyncDispatch } = useGlobalState();
    const [amlDetails, setAmlDetails] = useState();
    useEffect(() => {
        if (jobAMLResults) {
            asyncDispatch(retrieveAmlDetailed(jobSid)).then(setAmlDetails, console.error);
        }
    }, [asyncDispatch, jobSid, jobAMLResults]);
    if (!amlDetails)
        return (React.createElement(Dropdown, { title: "AML" },
            React.createElement(Box, null,
                React.createElement(AMLCaption, null),
                React.createElement(Icons.Loading, null))));
    const { data, monitoring, status } = amlDetails;
    if (!data || status === JobExecutionStatus.Error) {
        return (React.createElement(Dropdown, { title: "AML" },
            React.createElement(Box, null,
                React.createElement(AMLCaption, null),
                React.createElement(Text, null, "AML could not be completed. Please try again or contact support."))));
    }
    return (React.createElement(AMLCompletedResult, { amlDetailsData: data, hasMonitoringData: !!monitoring, isAMLOnly: isAMLOnly, jobErrors: jobErrors, jobStatus: jobStatus }));
};
